// ============================================================
// localEntityChanges.ts — "this tab just changed X" in-app signal.
//
// The presence socket's entity-changed channel is ECHO-SUPPRESSED for the
// actor (services/presence drops events whose actorUserId is the local user),
// so a screen that stays MOUNTED while the user changes something elsewhere —
// e.g. the calendar behind the task / appointment modal — never hears about
// its own user's writes. casevoApi publishes here after each successful task /
// appointment write, so such screens can refresh at once. Same tab only,
// synchronous, no network; other users still arrive via entity-changed.
// ============================================================
export interface LocalEntityChange {
  entity: 'task' | 'appointment'
  op: 'create' | 'update' | 'delete'
  id: string
}

type Listener = (e: LocalEntityChange) => void
const listeners = new Set<Listener>()

export const publishLocalEntityChange = (e: LocalEntityChange): void => {
  listeners.forEach((fn) => {
    try { fn(e) } catch { /* a failing subscriber never breaks the write path */ }
  })
}

export const subscribeLocalEntityChanges = (fn: Listener): (() => void) => {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}
